<script setup>
import { useRoute } from 'vue-router'
import routers from '@/router';
import { useI18n } from 'vue-i18n'
import { getPaypalBackApi } from '@/apis/order'

const { t, locale } = useI18n();
const router = useRoute()
console.log(router.params.redirect)
onMounted(async() => {
    if(router?.query?.token){
        console.log('router.params',router.query)
        const res = await getPaypalBackApi(router.query)
        if (res.code == 0) {
           console.log('res',res)
        }
    }
   
})
</script>


<template>
    <!-- {{ formatTime }} -->
    <div class="xtx-pay-page">
        <div class="container">
            <!-- 付款信息 -->
            <div class="pay-info">
                
                <div class="tip">
                    <span class="icon iconfont icon-queren2"></span>
                    <p>{{ $t('setup33') }}</p>
                   
                </div>
                <div class="amount">
                    <span v-if="router.params.redirect=='self'" @click="routers.push({ path: '/member/MallOrder' })">{{ $t('setup34') }}</span>
                    <span v-else @click="routers.push({ path: '/member/PurchasingOrder' })" >{{ $t('setup34') }}</span>
                </div>
            </div>
           
        </div>
    </div>
</template>

<style scoped lang="scss">
.xtx-pay-page {
    margin-top: 20px;
}

.pay-info {

    background: #fff;
    display: flex;
    align-items: center;
    height: 400px;
    padding: 0 80px;

    .icon {
        font-size: 80px;
        color: #1dc779;
    }

    .tip {
        padding-left: 10px;
        flex: 1;
        display: flex;
        align-items: center;

        p {
            &:first-child {
                font-size: 20px;
                margin-bottom: 5px;
            }

            &:last-child {
                color: #999;
                font-size: 16px;
            }
        }
    }

    .amount {
        span {
            &:first-child {
                font-size: 16px;
                color: #999;
            }

            &:last-child {
                color: $priceColor;
                font-size: 20px;
            }
        }
    }
}

.pay-type {
    margin-top: 20px;
    background-color: #fff;
    padding-bottom: 70px;

    p {
        line-height: 70px;
        height: 70px;
        padding-left: 30px;
        font-size: 16px;

        &.head {
            border-bottom: 1px solid #f5f5f5;
        }
    }

    .btn {
        width: 150px;
        height: 50px;
        border: 1px solid #e4e4e4;
        text-align: center;
        line-height: 48px;
        margin-left: 30px;
        color: #666666;
        display: inline-block;

        &.active,
        &:hover {
            border-color: $xtxColor;
        }

        &.alipay {
            background: url(https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/7b6b02396368c9314528c0bbd85a2e06.png) no-repeat center / contain;
        }

        &.wx {
            background: url(https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/c66f98cff8649bd5ba722c2e8067c6ca.jpg) no-repeat center / contain;
        }
    }
}
/* 响应式设计 */
@media (max-width: 768px) {
    .xtx-pay-page {
    margin-top: 0px;
    height: 100%;
}
.container{
    width: 100%;
    background: #fff;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    
}
.pay-info {

margin-top: -180px;
    background: #fff;
    display: flex;
    align-items: center;
    height: 160px;
    padding: 0 0px;
    flex-direction: column;
    .icon {
        font-size: 60px;
        color: #1dc779;
    }

    .tip {
        padding-left: 10px;
        flex: 1;
        display: flex;
        align-items: center;
        p {
            &:first-child {
                font-size: 20px;
                margin-bottom: 5px;
            }

            &:last-child {
                color: #999;
                font-size: 16px;
            }
        }
    }

    .amount {
        span {
            &:first-child {
                font-size: 14px;
                color: #999;
            }

            &:last-child {
                color: $priceColor;
                font-size: 14px;
            }
        }
    }
}

.pay-type {
    margin-top: 20px;
    background-color: #fff;
    padding-bottom: 70px;

    p {
        line-height: 70px;
        height: 70px;
        padding-left: 30px;
        font-size: 16px;

        &.head {
            border-bottom: 1px solid #f5f5f5;
        }
    }

    .btn {
        width: 150px;
        height: 50px;
        border: 1px solid #e4e4e4;
        text-align: center;
        line-height: 48px;
        margin-left: 30px;
        color: #666666;
        display: inline-block;

        &.active,
        &:hover {
            border-color: $xtxColor;
        }

        &.alipay {
            background: url(https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/7b6b02396368c9314528c0bbd85a2e06.png) no-repeat center / contain;
        }

        &.wx {
            background: url(https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/c66f98cff8649bd5ba722c2e8067c6ca.jpg) no-repeat center / contain;
        }
    }
} 
}
</style>